
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/destinations/xtremepush",
      function () {
        return require("private-next-pages/destinations/xtremepush.mdx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/destinations/xtremepush"])
      });
    }
  